export const FOLLOWING_WIDGET = {
  ACTION_TYPES: {
    entitySelectHandler: 'entitySelectHandler',
    displayHandler: 'displayHandler',
  },

  ANALYTICS: {
    ACTION_TYPES: {
      followingEntityClick: 'followingEntityClick',
      followingBrowseClick: 'followingBrowseClick'
    },

    SOURCE: {
      sideMenu: 'side-menu',
      followingStrip: 'following-strip',
      followingScreen: 'following-screen',
      bottomNavigationBar: 'strip-bar'
    },

    DESIGN_TYPE: {
      basic: 'basic',
      tabs: 'tabs'
    },

    TAB_TYPES: {
      teams: 'teams',
      leagues: 'leagues',
    }
  },

  IMAGE_SIZES :{
    remove: 14,
    logo: 32,
    emptyState: 34
  }
};